import { validate as validateUuid } from 'uuid';

const EMAIL_REGEX =
  /* eslint-disable @stylistic/max-len */
  /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;

export function isEmailValid(email = '') {
  return EMAIL_REGEX.test(email);
}

export function isValidUuid(value: string) {
  return validateUuid(value);
}

export function removeWhitespaces(value: string) {
  return value.trim();
}

export function toLowerCase(value: string) {
  return value.toLowerCase();
}

export function removeLeadingTrailingPeriods(value: string) {
  return value.replace(/^\./, '').replace(/\.$/, '');
}

export function removeAccents(value: string) {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function removeCharactersBetween({
  value,
  start,
  end,
}: {
  value: string;
  start: string;
  end: string;
}) {
  const startIndex = value.indexOf(start);
  const endIndex = value.indexOf(end);
  return startIndex !== -1 && startIndex < endIndex
    ? value.slice(0, startIndex) + value.slice(endIndex)
    : value;
}

export function removeLeadingSlash(value: string) {
  return value.startsWith('/') ? value.slice(1) : value;
}

export function addLeadingSlash(value: string) {
  return value.startsWith('/') ? value : `/${value}`;
}
